export default (layer) =>
  layer &&
  layer.dynamicFacets &&
  layer.fixedFacets &&
  (layer.dynamicFacets.length > 0 || layer.fixedFacets.length > 0);
